import { Grid, Modal, Box, ButtonBase } from "@mui/material";
import React, { useContext } from "react";
import { motion } from "framer-motion";
import { MainContext } from "../App";
import { CloseRounded } from "@mui/icons-material";
import AudioManager from "../@shared/utils/AudioManager";
import { DarkSurface } from "./ui";
import { colors, fonts, gradients, shadows } from "../@shared/ui/tokens";

const ModalComponent = ({ modalOpen, setModalOpen, aspectRatio = "5/6", padding = 2, md = 8, lg = 6, minHeight = 40, maxHeight, ingnorAspect = false, iconCloseButton = false, children }) => {
  const { deviceType } = useContext(MainContext);

  const close = () => {
    AudioManager.playSFX("buttonPress");
    setModalOpen(false);
  };

  return (
    <Modal open={!!modalOpen} onClose={close}>
      <Grid
        item
        container
        xs={11}
        md={md}
        lg={lg}
        style={{
          height: maxHeight ? `${maxHeight}dvh` : undefined,
          maxHeight: "92dvh",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          aspectRatio: (deviceType === "mobile" || !ingnorAspect) && aspectRatio,
          outline: "none",
        }}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.94, y: 14 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ type: "spring", stiffness: 380, damping: 30 }}
          style={{ width: "100%", height: "100%", position: "relative" }}
        >
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: "100%",
              borderRadius: "20px",
              overflow: "hidden",
              background: `${gradients.panelSheen}, ${gradients.panel}`,
              border: `1px solid ${colors.lineStrong}`,
              boxShadow: `${shadows.panel}, 0 0 60px rgba(124, 92, 255, 0.28)`,
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: "8%",
                right: "8%",
                height: "1px",
                background: gradients.goldLine,
                zIndex: 2,
                pointerEvents: "none",
              },
            }}
          >
            <Grid
              item
              container
              xs={12}
              sx={{
                height: "100%",
                p: padding,
                pb: padding + 2,
                boxSizing: "border-box",
                // Shared title treatment for the h6 headers modals render.
                "& .MuiTypography-h6": {
                  fontFamily: fonts.display,
                  fontWeight: "400 !important",
                  fontSize: { xs: "1.45rem", md: "1.7rem" },
                  letterSpacing: "0.02em",
                  lineHeight: 1.15,
                  backgroundColor: "transparent !important",
                  backgroundImage: `${gradients.goldLine} !important`,
                  backgroundSize: "70% 1px !important",
                  backgroundPosition: "center bottom !important",
                  backgroundRepeat: "no-repeat !important",
                  borderRadius: "0 !important",
                  pb: "10px !important",
                  textShadow: "0 2px 12px rgba(0,0,0,0.5)",
                },
              }}
            >
              <Grid item container xs={12} style={{ height: "100%", overflow: "hidden", padding: 8, alignContent: "flex-start" }}>
                <DarkSurface>{children}</DarkSurface>
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{
              position: "absolute",
              bottom: "-20px",
              left: 0,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              zIndex: 3,
            }}
          >
            <ButtonBase
              aria-label="Close"
              onClick={close}
              sx={{
                height: 40,
                minWidth: iconCloseButton ? 40 : 132,
                px: iconCloseButton ? 0 : 3,
                gap: 0.75,
                borderRadius: 999,
                fontFamily: fonts.display,
                fontSize: "1.05rem",
                letterSpacing: "0.06em",
                color: "#fff",
                background: "linear-gradient(180deg, #3a2387 0%, #1d0f4a 100%)",
                border: `1px solid ${colors.lineStrong}`,
                boxShadow: `0 10px 24px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.18), 0 0 0 4px rgba(7,3,15,0.85)`,
                transition: "transform 150ms ease, filter 150ms ease",
                "&:hover": { transform: "translateY(-1px)", filter: "brightness(1.15)" },
                "&:active": { transform: "scale(0.97)" },
                "& svg": { fontSize: 22 },
              }}
            >
              <CloseRounded />
              {!iconCloseButton && "Close"}
            </ButtonBase>
          </Box>
        </motion.div>
      </Grid>
    </Modal>
  );
};

export default ModalComponent;
